/**
 * 감정항목(appraisal_item) API — 본사(HQ) 전용.
 */
import api from './index'

/**
 * @param {string} spotType - GOLD | SILVER
 */
export function getAppraisalItemList(spotType) {
  return api.get('/api/v1/appraisal-item', { params: { spotType } })
}

export function getAppraisalItemDetail(appraisalItemCode) {
  return api.get(`/api/v1/appraisal-item/${appraisalItemCode}`)
}

/**
 * @param {Object} data - { spotType, appraisalItemType, appraisalItemName, standardPercent?, conversionPercent? }
 */
export function createAppraisalItem(data) {
  return api.post('/api/v1/appraisal-item', data)
}

/**
 * @param {Object} data - { spotType, appraisalItemType, appraisalItemName, standardPercent?, conversionPercent? }
 */
export function updateAppraisalItem(appraisalItemCode, data) {
  return api.put(`/api/v1/appraisal-item/${appraisalItemCode}`, data)
}

export function deleteAppraisalItem(appraisalItemCode) {
  return api.delete(`/api/v1/appraisal-item/${appraisalItemCode}`)
}
